// Updated App.js to use a single Router (provided by index.js)
import React from 'react';
import { AuthProvider } from './auth/auth-context';
import AppRoutes from './routes/routes';
import { OrgProvider } from './pages/orgs/org-context';
import { ControlPlaneProvider } from './controlPlane/ControlPlaneProvider';
import { ProjectProvider } from './pages/projects/project-context';
import { BrandingProvider } from './contexts/BrandingContext';
import { ToastContainer, Slide } from 'react-toastify';
import { HelpProvider } from './help/HelpContext';
import HelpDrawer from './help/HelpDrawer';

import './App.css';
import './styles/typography.css';

export default function App() {
  return (
    <>
      <AuthProvider>
        <OrgProvider>
          <ControlPlaneProvider>
          <BrandingProvider>
            <ProjectProvider>
              <HelpProvider>
                <AppRoutes />
                <HelpDrawer />
              </HelpProvider>
            </ProjectProvider>
          </BrandingProvider>
          </ControlPlaneProvider>
        </OrgProvider>
      </AuthProvider>
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={true}
        closeOnClick
        pauseOnHover
        theme="colored"
        transition={Slide}
      />
    </>
  );
}
